'use client';

import { create } from 'zustand';

import type { ItemUI } from '@libs/common-node';

type DrawerAction = {
    text: string;
    href?: string;
    onClick?: () => void;
};

export type DrawerItem = Pick<
    ItemUI,
    'sku' | 'name' | 'image' | 'autoshipFrequency' | 'autoshipFrequencyUnitOfMeasure'
>;

export type DrawerContent = {
    title?: string;
    subtitle?: string;
    primaryAction?: DrawerAction;
    secondaryAction?: DrawerAction;
};

export type OpenWithOptions = {
    stacked?: boolean;
};

type State = {
    isOpen: boolean;
    stacked: boolean;
    items: DrawerItem[];
    content: DrawerContent;
    openWith: (items: DrawerItem[], content?: DrawerContent, options?: OpenWithOptions) => void;
    close: () => void;
};

export const useCartConfirmDrawer = create<State>()(set => ({
    isOpen: false,
    stacked: false,
    items: [],
    content: {},
    openWith: (items, content, options) =>
        set({ isOpen: true, items, content: content ?? {}, stacked: options?.stacked ?? false }),
    close: () => set({ isOpen: false, stacked: false, items: [], content: {} }),
}));
